import React from 'react';
import { Nav } from 'react-bootstrap';
import '../style/sidebar.css'; // Estilos customizados
import menuLogo from "../assets/imagens/pentalobe.png";
const SidebarUser = ({ isOpen }) => {
  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      {/* Logo */}
      <div className="sidebar-header d-none d-lg-block">
        <img className="fundo-imagem-dasboard" src={menuLogo} alt="fundo-imagem-dasboard" />
      </div>

      {/* Menu de navegação */}
      <Nav defaultActiveKey="/dashboard" className="flex-column">
        <Nav.Link href="/dashboard" className="d-flex align-items-center">
          <i className="fas fa-home me-2"></i>
          <span className="d-none d-lg-block">Home</span>
        </Nav.Link>
        <Nav.Link href="/propostas-user" className="d-flex align-items-center">
          <i className="fa-solid fa-business-time me-2"></i>
          <span className="d-none d-lg-block">Pedido de Vendas</span>
        </Nav.Link>
        <Nav.Link href="/pedidos" className="d-flex align-items-center">
          <i className="fa-solid fa-cart-shopping me-2"></i>
          <span className="d-none d-lg-block">Pedido de Compras</span>
        </Nav.Link>
        <Nav.Link href="/editar-usuario" className="d-flex align-items-center">
          <i className="fa-solid fa-user-tie me-2"></i>
          <span className="d-none d-lg-block">Cadastro</span>
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default SidebarUser;
